<div class="grading-container"
[hidden]="(question.RTIModuleType && (question.RTIModuleType == 6 || question.RTIModuleType == 4)) 
|| 
(question.TemplateComponentType && (question.TemplateComponentType == 9 || question.TemplateComponentType == 1 || question.TemplateComponentType == 4 || question.TemplateComponentType == 8))"
[formGroup]="gradeFormGroup" [class.noClick]="isConsumerCurriculum">

  <mat-radio-group class="grade-radio-container" formControlName="grade" fxLayout="column">
    <mat-radio-button *ngIf="!isConsumerCurriculum" value="notGraded">Not Graded</mat-radio-button>
    <mat-radio-button value="correct">Correct</mat-radio-button>
    <mat-radio-button value="incorrect">Incorrect</mat-radio-button>

    <div *ngIf="pointsAvailable > 1" fxLayout="row">

      <mat-radio-button value="partialCredit">Partial Credit</mat-radio-button>

      <div [hidden]="gradeFormGroup.disabled || gradeFormGroup.controls['grade'].value !== 'partialCredit'">

        <mat-form-field class="credit-input">
          <mat-select formControlName="partialCredit">
            <mat-option *ngFor="let partialCredit of partialCredits" [value]="partialCredit">
              {{ partialCredit }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
      </div>

    </div>

  </mat-radio-group>
</div>
